import { useSyncExternalStore } from 'react'

type Listener = () => void

const revisionByViewKey: Record<string, number> = {}
const listenersByViewKey: Record<string, Set<Listener>> = {}

export function bumpChartCrosshairRevision(viewKey: string) {
    revisionByViewKey[viewKey] = (revisionByViewKey[viewKey] ?? 0) + 1
    listenersByViewKey[viewKey]?.forEach((listener) => listener())
}

export function subscribeChartCrosshairRevision(viewKey: string, listener: Listener) {
    if (!listenersByViewKey[viewKey]) {
        listenersByViewKey[viewKey] = new Set()
    }
    listenersByViewKey[viewKey].add(listener)
    return () => {
        listenersByViewKey[viewKey]?.delete(listener)
    }
}

/** Subscribe only in series OHLC strip — avoids re-rendering the series-title toolbar on crosshair move. */
export function useChartCrosshairRevision(viewKey: string): number {
    return useSyncExternalStore(
        (listener) => subscribeChartCrosshairRevision(viewKey, listener),
        () => revisionByViewKey[viewKey] ?? 0,
        () => 0
    )
}
